export const WEBAPP_DOCUMENTSREPOSITORY_OPENEDDOCUMENT =
  'WEBAPP_DOCUMENTSREPOSITORY_OPENEDDOCUMENT';

export const WEBAPP_DOCUMENTSREPOSITORY_DOCUMENTADDEDMANUALLY =
  'WEBAPP_DOCUMENTSREPOSITORY_DOCUMENTADDEDMANUALLY';

export const WEBAPP_DOCUMENTSREPOSITORY_HOMETAXLETTER_UPLOAD_HELPER =
  'WEBAPP_DOCUMENTSREPOSITORY_HOMETAXLETTER_UPLOAD_HELPER';

export const WEBAPP_DOCUMENTSREPOSITORY_CLICKEDCONNECMINFIN =
  'WEBAPP_DOCUMENTSREPOSITORY_CLICKEDCONNECMINFIN';

export const WEBAPP_DOCUMENTSREPOSITORY_CONFIRMEDCONNECMINFIN =
  'WEBAPP_DOCUMENTSREPOSITORY_CONFIRMEDCONNECMINFIN';

export const WEBAPP_DOCUMENTSREPOSITORY_CLICKEDCONNECTINTERVAT =
  'WEBAPP_DOCUMENTSREPOSITORY_CLICKEDCONNECTINTERVAT';

export const WEBAPP_DOCUMENTSREPOSITORY_CLICKEDDISCONNECTINTERVAT =
  'WEBAPP_DOCUMENTSREPOSITORY_CLICKEDDISCONNECTINTERVAT';

export const WEBAPP_DOCUMENTSREPOSITORY_CLICKEDSYNCMINFIN =
  'WEBAPP_DOCUMENTSREPOSITORY_CLICKEDSYNCMINFIN';

export const WEBAPP_DOCUMENTSREPOSITORY_OPENEDDOCUMENTFROMTAXITEMALERT =
  'WEBAPP_DOCUMENTSREPOSITORY_OPENEDDOCUMENTFROMTAXITEMALERT';
